import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, Radio } from "lucide-react";

const NAV = [
  { to: "/security-services", label: "Services", testid: "nav-services-link" },
  { to: "/ontario-service-areas", label: "Service Areas", testid: "nav-cities-link" },
  { to: "/about-1st-nations-security", label: "About", testid: "nav-about-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-slate-950/85 border-b border-amber-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2.5 shrink-0" onClick={() => setOpen(false)}>
          <img src="/favicon.png" alt="1st Nations Security sun logo" className="h-9 w-9" />
          <span className="font-heading font-800 text-white text-lg leading-none tracking-tight">
            1st Nations <span className="text-amber-400">Security</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-1" data-testid="main-navigation">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={n.testid}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-amber-400 bg-amber-500/10" : "text-slate-300 hover:text-amber-300 hover:bg-white/5"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span data-testid="dispatch-status-badge" className="hidden lg:flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-emerald-400">
            <Radio className="h-3.5 w-3.5 animate-pulse" /> 24/7 Dispatch
          </span>
          <a
            href="tel:+18077700243"
            data-testid="header-call-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-amber-500 px-4 py-2 text-sm font-bold text-slate-950 transition-colors duration-200 hover:bg-amber-400"
          >
            <Phone className="h-4 w-4" /> +1 807-770-0243
          </a>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle navigation menu"
            onClick={() => setOpen(!open)}
            className="md:hidden text-slate-200 p-2"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-amber-500/10 bg-slate-950/95" data-testid="mobile-navigation">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`mobile-${n.testid}`}
              onClick={() => setOpen(false)}
              className="block px-6 py-3 text-slate-200 border-b border-white/5 hover:text-amber-400"
            >
              {n.label}
            </NavLink>
          ))}
          <a href="tel:+18077700243" data-testid="mobile-call-button" className="block px-6 py-3 text-amber-400 font-semibold">
            Call +1 807-770-0243
          </a>
        </nav>
      )}
    </header>
  );
};
